import { render, staticRenderFns } from "./NestFormItem.vue?vue&type=template&id=5c88faa3&scoped=true&"
import script from "./NestFormItem.vue?vue&type=script&lang=js&"
export * from "./NestFormItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c88faa3",
  null
  
)

export default component.exports